import { Button } from "@fluentui/react-components";
import React, { ForwardedRef } from "react";

type FolderUploaderProps = {
    isHidden?: boolean,
    handleFiles(files: FileList): void
};
export type FolderUploaderType = {
    resetValue(): void,
    click(): void
}

const FolderUploader = React.forwardRef<FolderUploaderType, FolderUploaderProps>((props, ref) => {

    React.useImperativeHandle(
        ref,
        () => ({
            resetValue() {
                resetValue();
            },
            click() {
                handleClick(null);
            }
        }));

    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef<HTMLInputElement>(null);

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleClick = (event: any) => {
        console.log("handleClick", hiddenFileInput.current);
        if (hiddenFileInput.current) {
            resetValue();
            hiddenFileInput.current.click();
        }

    };

    const resetValue = () => {
        console.log("FolderUploader resetValue called.");
        if (hiddenFileInput.current)
            hiddenFileInput.current.value = "";
    }
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChange = (event: any) => {
        console.log("folder uploader handle change event", event);
        const filesUploaded = event.target.files;
        props.handleFiles(filesUploaded);
    };
    return (
        <>
            <Button onClick={handleClick} style={{ marginLeft: "10px", marginRight: "10px", display: !!props.isHidden ? "none" : undefined }} >
                Upload folder
            </Button>
            <input
                type="file"
                //@ts-ignore
                webkitdirectory="" mozdirectory="" directory=""
                multiple
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </>
    );
});
export default FolderUploader;